import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_heading-2" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.modal)
  }, [
    _createVNode(_component_Toolbar, { class: "p-4" }, {
      left: _withCtx(() => [
        _createElementVNode("p", _hoisted_1, _toDisplayString($setup.current + 1) + " " + _toDisplayString($setup.currentItem.title), 1)
      ]),
      right: _withCtx(() => [
        _createVNode(_component_Button, {
          onClick: _cache[0] || (_cache[0] = () => $setup.callback(-1)),
          class: "p-button-outlined p-button-gray p-button-rounded mr-3 p-button-only-icon"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, { name: "arrow_left" })
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          onClick: _cache[1] || (_cache[1] = () => $setup.callback(1)),
          class: "p-button-outlined p-button-gray p-button-rounded mr-5 p-button-only-icon"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, { name: "arrow_right" })
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeModal'))),
          class: "p-button-outlined p-button-gray p-button-rounded p-button-only-icon"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, { name: "close" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.content)
    }, [
      _createElementVNode("img", {
        src: $setup.substrateImg,
        alt: "",
        class: _normalizeClass(_ctx.$style.substrate)
      }, null, 10, _hoisted_2),
      _createElementVNode("img", {
        alt: "",
        src: $setup.currentItem.base_64_image || $setup.currentItem.processed_url || $setup.currentItem.loaded_photo || $setup.currentItem.car,
        class: _normalizeClass([_ctx.$style.car, !($setup.currentItem.base_64_image || $setup.currentItem.processed_url || $setup.currentItem.loaded_photo) && _ctx.$style.carReference])
      }, null, 10, _hoisted_3),
      ($props.item.status == 1)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            isOverlay: true
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_Toolbar, { class: "p-4" }, {
      left: _withCtx(() => [
        _createElementVNode("label", {
          class: _normalizeClass([[_ctx.$style.action, $props.item.status == 1 || ($setup.photoUploading[$setup.currentItem.id] && 'disabled')], "p-button"])
        }, [
          _createElementVNode("input", {
            type: "file",
            name: "",
            id: "",
            disabled: $props.item.status == 1 || $setup.photoUploading[$setup.currentItem.id],
            class: "p-upload-input",
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.uploadFile && $setup.uploadFile(...args)))
          }, null, 40, _hoisted_4),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t($setup.currentItem.loaded_photo ? 'vehicles_page.replacePhoto' : 'vehicles_page.upload_photo')), 1)
        ], 2),
        _hoisted_5,
        _createElementVNode("label", {
          class: _normalizeClass([[_ctx.$style.action, $props.item.status == 1 || ($setup.photoUploading[$setup.currentItem.id] && 'disabled')], "p-button p-button-outlined p-button-gray"])
        }, [
          _createElementVNode("input", {
            type: "file",
            name: "",
            id: "",
            disabled: $props.item.status == 1 || $setup.photoUploading[$setup.currentItem.id],
            class: "p-upload-input",
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.uploadFileProcessed && $setup.uploadFileProcessed(...args)))
          }, null, 40, _hoisted_6),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t($setup.currentItem.loaded_photo ? 'vehicles_page.replacePhotoProcessed' : 'vehicles_page.uploadPhotoProcessed')), 1)
        ], 2)
      ]),
      right: _withCtx(() => [
        _createVNode(_component_Button, {
          class: _normalizeClass([_ctx.$style.action, "p-button-outlined p-button-gray ml-4"]),
          onClick: $setup.processing,
          disabled: $props.item.status == 1 || !$setup.currentItem.loaded_photo
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, { name: "upload-cloud" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('vehicles_page.processing')), 1)
          ]),
          _: 1
        }, 8, ["class", "onClick", "disabled"])
      ]),
      _: 1
    })
  ], 2))
}